import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { IonicModule, Platform } from '@ionic/angular';
import { SplashScreenManagerService } from './services/platform/capacitor/splash-screen-manager.service';
import { KeepAwakeManagerService } from './services/platform/capacitor/keep-awake-manager.service';
import { AppUpdateManagerService } from './services/platform/capacitor/app-update-manager.service';
import { AuthApiService } from './services/api/auth/auth-api.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonicModule],
})
export class AppComponent implements OnInit {

  private readonly platform = inject(Platform);
  private readonly splashScreenManager = inject(SplashScreenManagerService);
  private readonly keepAwakeManager = inject(KeepAwakeManagerService);
  private readonly appUpdateManager = inject(AppUpdateManagerService);
  private readonly auth = inject(AuthApiService);

  async ngOnInit() {
    await this.platform.ready();
    await this.splashScreenManager.hide();

    this.keepAwakeManager.watch();
    this.appUpdateManager.watch();

    this.auth.syncSentryUser();
  }
}
